<div class="timesheet__item timesheet-column--location">
  <timesheet-info [text]="location"></timesheet-info>
</div>
